import { FC, useCallback } from 'react'
import { DatePicker } from 'components/atoms/inputs/DatePicker/DatePicker'
import { CalendarDate, DateValue, getLocalTimeZone, isWeekend, today } from '@internationalized/date'
import { useLocale } from '@react-aria/i18n'

type RangedDatePickerProps = {
  label?: string
  value?: CalendarDate
  onChange?: (date: DateValue) => void
  showCalendar?: boolean
  highlightedDates?: CalendarDate[]
  disabledRanges?: CalendarDate[][]
  disableWeekends?: boolean
}

export const RangedDatePicker: FC<RangedDatePickerProps> = (props) => {
  const { disabledRanges, disableWeekends, highlightedDates, onChange, showCalendar, label, value } = props

  const { locale } = useLocale()
  const now = today(getLocalTimeZone())
  const isDateUnavailable = (date: DateValue) => {
    const dateIsWeekend = isWeekend(date, locale)
    const dateIsInDisabledRange = disabledRanges?.some(
      (interval) => date.compare(interval[0]) >= 0 && date.compare(interval[1]) <= 0
    )
    return !!dateIsInDisabledRange || !!(disableWeekends && dateIsWeekend)
  }

  const handleTodayClick = useCallback(() => {
    return !!onChange && onChange(now)
  }, [now, onChange])

  return (
    <DatePicker
      onChange={ onChange }
      label={ label }
      minValue={ today(getLocalTimeZone()) }
      value={ value }
      isDateUnavailable={ isDateUnavailable }
      highlightedDates={ highlightedDates }
      showCalendar={ showCalendar }
      onTodayClick={ handleTodayClick }
    />
  )
}
